module.exports = {
    menu: {
        index: "首页",
        signUp: "报名信息采集",
        live: "直播大厅",
        agenda: "大会日程",
        personal: "个人中心",
    },
    index: {
        src: "https://oss.eventnet.cn/H5/mi/pc_video_zh.mp4?v=1140",
        poster: "https://oss.eventnet.cn/H5/mi/pc_video_zh.png",
    },
    index_mobile: {
        src: "https://oss.eventnet.cn/H5/mi/mobile_video_zh.mp4?v=1140",
        poster: "https://oss.eventnet.cn/H5/mi/mobile_video_zh.png",
        gif: "https://oss.eventnet.cn/H5/mi/mobile_video_zh.gif"
    },
    share: {
        title: "小米集团投资者日",
        time_place: "2021.10.19 小米科技园",
        img: ""
    },
    signUp: {
        name: {
            title: "姓名",
            placeholder: "请输入姓名",
        },
        job_title: {
            title: "职务",
            placeholder: "请输入职务",
        },
        company: {
            title: "机构",
            placeholder: "请输入机构",
        },
        email: {
            title: "邮箱",
            title1: "登录邮箱",
            placeholder: "请输入邮箱",
            error: "邮箱格式有误",
        },
        password: {
            title: "设置密码",
            title2: "密码",
            title1: "报名信息",
            placeholder: "请输入密码",
            error: "密码最少8位",
            error1: "密码格式有误",
            tips1: "长度为8-14位之间",
            tips2: "字母、数字及标点符号至少包含2种",
            tips3: "不允许有空格、中文、特殊符号"
        },
        password1: {
            title: "确认密码",
            placeholder: "请确认密码",
            error: "输入密码不一致",
        },
        cellphone: {
            title: "电话",
            placeholder: "请输入电话",
            error: "请输入正确的电话"
        },
        country: {
            title: "国家",
            placeholder: "请输入国家",
        },
        region: {
            title: "地区",
            placeholder: "请输入地区",
        },
        meeting_type: {
            title: "会议类型",
            placeholder: "请选择会议类型",
            select: {
                checkA: { value: "线上会议", option: 2 },
                checkB: { value: "线下会议", option: 1 },
            }
        },
        is_dine: {
            title: "是否用餐",
            placeholder: "请选择是否用餐",
            select: {
                checkA: { value: "需要19日午餐", option: 1 },
                checkB: { value: "不需要", option: 2 },
            }
        },
        tips: "报名截止时间为10月8日",
        btn: "下一步",
        success: "提交成功",
        success_tip1: "尊敬的各位投资人：",
        success_tip2: "活动会务组已收到您的报名信息，后台审核通过后，我们会将确认信发送至您的邮箱。",
        success_tip3: "您可以于10月12日登陆本网站的个人中心，查看自己是否被允许参加本次会议。",
        success_tip4: "会议线上直播将于10月19日开启。",
        login_tips: "请先登录",
        tips_password: "密码用于登录使用",
        title1: "",
        error:"非常抱歉，因为线下参会名额的限制，已为您转为线上参会，敬请谅解！"
    },
    login: {
        title: "登 录",
        toRegister: "去注册",
        toLogin: "我已注册，去登录",
        success: "登录成功",
        password: "忘记密码？",
        signOut: "退出",
        please_register: "密码错误或用户不存在",
    },
    register: {
        title: "注 册",
        success: "注册成功",
        repeat: "请勿重复注册",
        last: "上一步",
        confirm: "完成",
        error: "请先完善信息"
    },
    personal: {
        tips1: "信息审核通过",
        tips2: "抱歉，信息审核未通过",
        tips3: "信息审核中..."
    },
    waiting: {
        title: "报名已截止，感谢您的关注"
    },
    password: {
        title: "请通过邮箱地址找回密码",
        title1: "请通过邮箱地址获取6位数字验证码",
        next: "下一步",
        confirm: "确认重置密码",
        btn: "点击获取",
        success: "修改成功",
        code: {
            title: "验证码",
            placeholder: "请输入验证码",
            success: "验证码已发送",
            error: "验证码有误"
        },
        password: {
            title: "新密码",
            placeholder: "请输入新密码",
            error: "密码最少6位",
        },
        password1: {
            title: "确认密码",
            placeholder: "请确认密码",
            error: "输入密码不一致",
        },
    },
    live:{
        liveNumber:'观看人数',
        send:'发  送',
        saySome:'说点什么...',
        YourComment:'请输入您的评论',
        Block:'禁言中',
        BlockTill:'禁言时间至',
        Interaction:'互动',
        CommentsUnderReview:'评论正在审核中…',
        downmsg:'下拉加载更多历史消息',
        newmsg:' 条新消息',
        live:'进入直播',
        livelink:'https://yunqicdn.aodianyun.com/play-162.html'
    },
    pcagenda:{
        src:'https://oss.eventnet.cn/H5/mi/agenda_zh.jpeg?v=1.11'
    },
    magenda:{
        src:'https://oss.eventnet.cn/H5/mi/agenda_m_zh.jpeg?v=1.11'
    }
};


// WEBPACK FOOTER //
// ./src/i18n/zh.js